import React from 'react'
import PropTypes from 'prop-types'

import CircularProgress from 'material-ui/CircularProgress'

import PhotoItem from './PhotoItem'

export default class PhotosPreview extends React.Component {

  static propTypes = {
    invoiceEditor: PropTypes.object.isRequired
  }

  render() {
    const loading = this.props.invoiceEditor.isLoadingPhotos()
    let content
    if (loading) {
      content = <div style={styles.progress}>
        <CircularProgress thickness={2} />
      </div>
    }
    const photos = this.props.invoiceEditor.getPhotos() || []
    if (!loading && !photos.length) {
      return null
    }
    if (!loading) {
      content = <div style={styles.list}>
        { photos.map((photo, index) =>
          <PhotoItem
            key={index}
            selectable={false}
            photo={photo}
            sample='small'
            style={index < photos.length - 1 && styles.photosDivider || {}}/>)
        }
      </div>
    }
    return (
      <div style={styles.container}>
        <div style={styles.darkLabel}>PHOTOS</div>
        { content }
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 32,
    paddingRight: 32,
    paddingBottom: 48
  },
  progress: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: 22
  },
  darkLabel: {
    fontSize: 14,
    color: '#1f2229',
    marginBottom: 22
  },
  photosDivider: {
    marginRight: 6
  },
  list: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  }
}


// WEBPACK FOOTER //
// ./src/billing/invoices/modules/photos/PhotosPreview.js